import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.DearSearchFields', {
    dearSectionHeader: 'DEAR PRODUCTS',
    dearSectionOrderNumber: 'Order Number',
    dearSectionOrderNumberPlaceholder: 'Enter order number',
    dearSectionLocation: 'Location',
    dearSectionLocationPlaceholder: 'Select a location',
    dearSectionSupplier: 'Supplier',
    dearSectionSupplierPlaceholder: 'Select a supplier',
    dearSectionProduct: 'Product',
    dearSectionProductPlaceholder: 'Select a product',
    dearSectionAccount: 'Inventory Account',
    dearSectionAccountPlaceholder: 'Select an account',
    dearSectionOrderDate: 'Order Date',
    dearSectionRequiredBy: 'Required by',
    dateGreaterEqualsPlaceholder: 'Enter date',
    dateLessEqualsPlaceholder: 'Enter date',
    dateFieldTitle: 'Date',
    dateFromLabel: 'From',
    dateToLabel: 'To',
});
